<template>
  <div
    class="
      footer
      d-flex
      align-items-center
      flex-flow-column
      justify-content-center
      position-relative
    "
  >
    <!-- <div class="d-flex align-items-center size-14">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="pl-12"
        @click="handleLink(item)"
      >
        <el-link>{{ item.text }}</el-link>
      </div>
    </div> -->
    <div class="size-12 mt-4 mb-4">2019-2026 Ujoyverse Limited. Copyrights Reserved.</div>

    <div class="size-12  center">
      <!-- 健康游戏忠告：抵制不良游戏 拒绝盗版游戏 注意自我保护 谨防受骗上当
      适度游戏益脑 沉迷游戏伤身 合理安排时间 享受健康生活 -->
      <div>
        New Stage in Brand Growth，Endless possibilities in overseas
        markets；Investing in development，Building towards the best
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          text: "Contact Us",
          url: "#/tel",
          tag: "Contact",
        },
        // {
        //   text: "Join Us",
        //   url: "join",
        //   tag: "Join",
        // },
        {
          text: "Privacy Policy",
          url: "https://privacy.ujoygames.com/",
          tag: "Policy",
        },
        {
          text: "User Agreement",
          url: "https://useragreement.ujoygames.com/",
          tag: "Agreement",
        },
      ],
    };
  },
  methods: {
    handleLink(item) {
      if (item.tag === "Policy" || "Agreement") {
        window.open(item.url, "_blank");
      } else {
        this.$router.push({ path: item.url });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.footer {
 

    height: 80px;
  background: #fff;
  color: #6d6d6d;
  z-index: 2;
  box-shadow: 0 0 2px rgba($color: #000000, $alpha: 0.2);



  position: fixed;
    bottom: 0;
    width: 100%;
}
// @media screen and (max-width:1200px) {
//   .footer{
//     bottom: 2.9vh !important;
//   }
// }
</style>


// WEBPACK FOOTER //
// src/layout/components/FooterMenu/index.vue